import { OEInputModel } from "./oe-input.model";
import { OENEntryType } from "../enums/oe-entry-type.enum";

export class OEDLoadingDataModel {
  public refId: string;
  public entryType: OENEntryType;
  public blockPropagation: boolean;
  public values: Array<OEInputModel>;
  public algoValues: Array<OEInputModel>;
  public singlePropagation: boolean;

  constructor(
    _refId: string,
    _entryType: OENEntryType,
    _blockPropagation: boolean,
    _values: Array<OEInputModel>,
    _algoValues: Array<OEInputModel>,
    _singlePropagation: boolean = false,
  ) {
    this.refId = _refId;
    this.entryType = _entryType;
    this.blockPropagation = _blockPropagation;
    this.values = _values instanceof Array ? _values : null;
    this.algoValues = _algoValues instanceof Array ? _algoValues : null;
    this.singlePropagation = _singlePropagation;
  }
}
